module.exports = __webpack_public_path__ + "img/logo_m.cc4df852.png";